export enum Color {
    HeaderBackground = 'rgb(0, 120, 212);',
    Primary = '#0077D7',
    White = '#ffffff',
    Black = '#000000',
    BotBackground = '#F2F2F2',
    FooterBackground = '#E5E5E5',
}
